module.exports = __webpack_public_path__ + "img/moto.aefaae07.png";